import styled from "styled-components";
import { ReactComponent as CheckSVG } from 'assets/icons/check.svg'

export const Container = styled.div`
  min-height: 100%;
  height: 100%;
`

export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Header = styled.header`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 12px;

  img {
    width: 100%;
    max-width: 120px;
    border-radius: 6px;
  }

  ${({ theme }) => theme.old.breakpoints.isMobileBig} {
    flex-direction: column;

    img {
      max-width: unset;
    }
  }
`

export const Body = styled.p`
  font-size: ${({ theme }) => theme.old.fonts.size.small};
  font-weight: ${({ theme }) => theme.old.fonts.weight.regular};
  color: ${({ theme }) => theme.old.colors.gray[525]};
  line-height: 20px;

  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Footer = styled.footer`
  margin-top: 16px;
  display: flex;
  align-items: flex-end;
  flex-grow: 1;

  div {
    display: flex;
    align-items: center;
    gap: 6px;
    height: fit-content;

    font-size: ${({ theme }) => theme.old.fonts.size.small};
    font-weight: ${({ theme }) => theme.old.fonts.weight.regular};
    line-height: 20px;
  }
`

export const Check = styled(CheckSVG)`
  background-color: ${({ theme }) => theme.old.colors.gray[50]};
  color: ${({ theme }) => theme.old.colors.gray[190]};
  border-radius: 100%;
  padding: 4px;
  height: 20px;
  width: 20px;
`

export const TitleWrapper = styled.div`
  display: grid;
  width: 100%;
  place-items: center left;

  h3 {
    margin-bottom: 4px;
    font-size: ${({ theme }) => theme.old.fonts.size.normal};
    font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
    line-height: 24px;

    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  p {
    font-size: ${({ theme }) => theme.old.fonts.size.small};
    font-weight: ${({ theme }) => theme.old.fonts.weight.regular};
    line-height: 20px;
  }

`